import { api } from "./client";

export type Invite = {
	id: string;
	code: string;
	url: string;
	createdBy: string;
	usedBy: string | null;
	useCount: number;
	expiresAt: string | null;
	deletedAt: string | null;
	createdAt: string;
};

export const invitesApi = {
	list: (archived = false) =>
		api.get<{ invites: Invite[] }>(
			`/invites${archived ? "?archived=1" : ""}`,
		),
	create: (expiresInDays = 7) =>
		api.post<{ invite: Invite }>("/invites", { expiresInDays }),
	archive: (id: string) => api.del<{ ok: boolean }>(`/invites/${id}`),
	accept: (input: {
		code: string;
		email: string;
		name?: string;
		password: string;
	}) =>
		api.post<{
			user: {
				id: string;
				email: string;
				name: string;
				image: string | null;
				emailVerified: boolean;
				isAdmin: boolean;
			};
		}>("/auth/accept-invite", input),
};
